/*
 * Copyright © 2018-2021, GlobalVET AB
 *
 * All rights reserved. No part or the whole of this source code and the compiled program
 * may be reproduced, copied, distributed, disseminated to the public, adapted or transmitted
 * in any form or by any means, including photocopying, recording, or other electronic or
 * mechanical methods, without the prior written permission of GlobalVET AB. This source code
 * and the compiled program may only be used for the purposes of GlobalVET AB. This source code
 * and the compiled program shall be kept confidential and shall not be made public or made
 * available or disclosed to any unauthorized person. Any dispute or claim arising out of the
 * breach of these provisions shall be governed by and construed in accordance with the
 * laws of Sweden.
 */

export const notificationTypeEn = {
  CLINIC_DATA_EXPORT_CREATED: "When a clinic data export has been created",
  CLINIC_EMPLOYMENT_REQUEST: "When I am invited to work at a clinic",
  CLINIC_EMPLOYMENT_REQUEST_ACCEPTED: "When someone accepts my invitation to join my clinic",
  CLINIC_EMPLOYMENT_REQUEST_REJECTED: "When someone declines my invitation to join my clinic",
  CLINIC_EMPLOYMENT_REQUEST_REVOKED: "When my invitation to work at a clinic is revoked",
  INVOICE_CREATED: "When a new invoice is created",
  INVOICE_PAYMENT_REMINDER: "When an invoice payment is due",
  LINKED_UNREGISTERED_PETS: "When my pet's data is registered at a new clinic",
  MEDICAL_RECORD_CREATED: "When a new medical record is created",
  PAYMENT_FAILED: "When a GlobalVET invoice payment fails",
  PAYMENT_SUCCEEDED: "When a GlobalVET invoice payment is successful",
  PET_OWNER_INVITATION: "When a pet owner is invited",
  PET_TRANSFER_INVITATION: "When a pet owner invites me to take over their pet",
  PET_TRANSFER_NEW_OWNER: "When a pet is transferred to me",
  PET_TRANSFER_OLD_OWNER: "When the new owner accepts the transfer of my pet",
  PET_TRANSFER_REJECTED: "When a pet transfer request is declined",
  POLICY_CHANGE: "When the terms and conditions of GlobalVET has changed",
  RESERVATION_CANCELLED: "When my appointment is cancelled",
  RESERVATION_CANCELLED_BY_OWNER: "When an appointment is cancelled by a pet owner at my clinic",
  RESERVATION_CREATED: "When a new appointment is scheduled",
  RESERVATION_MODIFIED: "When my appointment details are modified",
  RESERVATION_REMINDER: "When my appointment is approaching",
  TRIAL_END_REMINDER: "When my trial period is ending soon",
  VET_PROFESSION_APPROVED: "When my uploaded veterinary document is approved",
  VET_PROFESSION_REJECTED: "When my uploaded veterinary document is rejected",

  ANNOUNCEMENT: "Announcement",
  SYSTEM_INFORMATION: "System information",
  MARKETING: "Marketing and promotion",
  CUSTOM: "Custom message",
};
